import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function CMEMS() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all third-party datasets.
        However, errors and inconsistencies inherited from these datasets (for example, missing
        values) may appear as errors in extracted data. If you encounter incorrect values such as
        NaN or erroneous zero values in extracted boundary conditions, initial conditions, or
        forcings output files, please contact{' '}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        The data set from Copernicus (The European earth observation program from EU) include Global
        ocean data from the Copernicus Marine Environment Monitoring Service (CMEMS). The CMEMS has
        been designed to respond to issues emerging in the different sectors. Using information from
        both satellite and in situ observations, it provides state-of-the-art analyses and forecasts
        daily, which offer an excellent capability to observe, understand and anticipate marine
        environment events.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>
              Global Ocean Sea Physical Analysis and Forecast Product from Copernicus (CMEMS)
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Ocean data</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>Global_Analysis_Forecast_PHY_001_024</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>Copernicus Marine Environment Monitoring Service (CMEMS)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product type</TableCell>
            <TableCell>Grid</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a href="https://marine.copernicus.eu/" target="_blank" rel="noopener noreferrer">
                CMEMS home
              </a>
              <br />
              <a
                href="https://data.marine.copernicus.eu/product/GLOBAL_ANALYSISFORECAST_PHY_001_024/description"
                target="_blank"
                rel="noopener noreferrer">
                Data product description: Global Ocean Physics Analysis and Forecast | Copernicus Marine Service
              </a>
              <br />
              <a
                href="https://catalogue.marine.copernicus.eu/documents/PUM/CMEMS-GLO-PUM-001-024.pdf"
                target="_blank"
                rel="noopener noreferrer">
                Data product user manual: CMEMS-GLO-PUM-001-024.pdf (copernicus.eu)
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Longitude: -180°W to 180°E <br /> Latitude: 90°S to 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>1/12 deg. (approx. 0.083 deg.)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Range</TableCell>
            <TableCell>From 0 m down to -5500 m</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Resolution</TableCell>
            <TableCell>50 levels</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage: <br />
              1/1-2016 -&gt; Present
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>Daily (daily mean values)</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Sea Surface Height [m]
              <br />
              Water Temperature [deg C]
              <br />
              Salinity [psu]
              <br />
              U-velocity component (East dir.) [m/s]
              <br />
              V-velocity component (North dir.) [m/s]
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Data product originator</TableCell>
            <TableCell>E.U. Copernicus Marine Service Information</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
